import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { setupAxiosInterceptors } from './utils/auth';
import { offlineAdapter } from './utils/offlineAdapter';
import { SyncProvider } from './context/SyncContext';

// Set offline adapter as default for all axios instances
axios.defaults.adapter = offlineAdapter;

// Setup axios to auto-attach JWT token and handle 401 auto-logout
setupAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SyncProvider>
      <App />
    </SyncProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
